/*
taken from https://github.com/dvtng/react-loading-skeleton/

the original library had a dependecy on "@emotion/core" that we'd like to avoid

Usage:
<Skeleton/> // Simple, single-line loading skeleton
<Skeleton count={5}/> // Five-line loading skeleton

<h1>{this.props.title || <Skeleton />}</h1>
{this.props.body || <Skeleton count={10} />}

*/
import React from 'react'
import SkeletonMUI from '@mui/material/Skeleton'
export default function Skeleton({
  count = 1,
  duration = 1.2,
  width = null,
  wrapper: Wrapper = null,
  height = null,
  circle = false,
  className = null,
}) {
  const elements = []

  for (let i = 0; i < count; i++) {
    let style = {}

    if (width !== null) {
      style.width = width
    }

    if (height !== null) {
      style.height = height
    }

    if (width !== null && height !== null && circle) {
      style.borderRadius = '50%'
    }

    elements.push(
      <span key={i} className="react-loading-skeleton" style={style}>
        &zwnj;
      </span>,
    )
  }

  return (
    <span className={className}>
      {Wrapper
        ? elements.map((element, i) => (
            <Wrapper key={i}>
              {element}
              &zwnj;
            </Wrapper>
          ))
        : elements}
    </span>
  )
}

export const generateMuiSkeletons = (arrayLength, gap = 2) => {
  return Array.from({ length: arrayLength }, (_, i) => (
    <SkeletonMUI
      key={`skel-${i}`}
      variant="rectangular"
      width={'100%'}
      height={40}
      sx={{ marginBottom: gap }}
    />
  ))
}
